var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KSnackbar',{attrs:{"isOpen":true,"text":"Item deleted","actionText":"Undo","duration":0}})
}
var staticRenderFns = []

export { render, staticRenderFns }